import type { en } from "./en";

export const de: { [K in keyof typeof en]: string } = {
  close: "Schließen",
  howToPlay: "So spielt man",
  dash: "Dash",
  duel: "Duell",
  ranks: "Rangliste",
  garage: "Garage",
  shop: "Shop",
  settings: "Einstellungen",
  tagline: "Neon-Kurier. Nicht crashen.",
  bestMeters: "Best {n} m · {diff}",
  pause: "Pause",
  paused: "Pause",
  resume: "Weiter",
  endRun: "Run beenden",
  sound: "Ton",
  on: "An",
  off: "Aus",
  muted: "Stumm",
  muteSfx: "Musik & SFX stumm",
  pbGhost: "PB-Geist",
  ads: "Werbung",
  adsOff: "Aus",
  adsConsentOff: "{mode} · Einwilligung aus",
  language: "Sprache",
  langEn: "English",
  langFr: "Français",
  langIt: "Italiano",
  langEs: "Español",
  langDe: "Deutsch",
  pseudoRanks: "Pseudo (Rangliste)",
  pseudoHint:
    "Für die Rangliste gespeichert. Hier jederzeit änderbar — nicht nach jedem Run. Kein Apple-Account nötig.",
  gameCenter: "Game Center",
  open: "Öffnen",
  gcOpening: "Game Center wird geöffnet…",
  gcIos: "Game Center gibt’s nur auf iOS.",
  gcSignIn: "In den Einstellungen bei Game Center anmelden, dann erneut versuchen.",
  gcHint: "Apple-Ranglisten & Erfolge. Getrennt von der In-App-Rangliste.",
  signInApple: "Mit Apple anmelden",
  linked: "Verknüpft",
  link: "Verknüpfen",
  appleLinked: "Apple verknüpft — die Rangliste folgt dieser ID.",
  appleLinkedWeb: "Apple verknüpft (Web-Test).",
  appleWaiting: "Warte auf Apple…",
  appleCancel: "Abgebrochen — nichts verknüpft.",
  appleFail:
    "Apple ist nicht durchgelaufen (oft einmaliger Index-Delay). Spiel mit deinem Pseudo, versuch’s später.",
  appleHint:
    "Optional. Bindet die Rangliste an diese Apple-ID auf allen Geräten. Zum Spielen nicht nötig.",
  appleLinkedHint: "Ranglisten-ID an Apple gebunden. Pseudo oben bleibt editierbar.",
  restorePurchases: "Käufe wiederherstellen",
  restoring: "Wird wiederhergestellt…",
  restored: "Käufe wiederhergestellt (falls vorhanden).",
  restoreFail: "Wiederherstellen fehlgeschlagen: {reason}",
  restoreIos: "Wiederherstellen gibt’s nur auf iOS.",
  appleId: "Apple-ID",
  adPrivacy: "Werbe-Optionen",
  manage: "Verwalten",
  privacy: "Datenschutz",
  support: "Support",
  settingsHint:
    "Swipe L/R zum Spurwechsel. Swipe hoch zum Springen — sammle cyan ↑-Tokens (max. {n}). Sprung über Barriers, Kisten, Löcher und Autos — nicht Trucks. Garage → Welten für Mond / Magma.",
  playingAs: "Du spielst als {name}",
  noPseudo: "Noch kein Pseudo — setz eins in den Einstellungen",
  loading: "Lädt…",
  noScores: "Noch keine Scores — sei #1",
  difficultyLocked: "Schwierigkeit für dieses Duell gesperrt.",
  diffNote: "Mittel nach 3 Runs · Schwer nach 12. Tempo steigt im Run.",
  diffEasy: "Leicht",
  diffMedium: "Mittel",
  diffHard: "Schwer",
  hintEasy: "Chill",
  hintMedium: "Arcade",
  hintHard: "Insane",
  runsLeft: "{n} Runs",
  runLeft: "1 Run",
  swipeHint: "Swipe L/R · swipe hoch zum Springen",
  swipeHintPower: " · tipp ⚡ · halten = AUTO",
  speedUp: "SPEED UP",
  powerMagnet: "Magnet",
  powerPhase: "Phase",
  powerDefault: "Power",
  powerOn: "ON",
  powerAuto: "AUTO",
  powerHoldHint: "Tippen zum Aktivieren · halten für AUTO",
  powerAria: "{label}{auto} — halten für AUTO",
  powerAriaAuto: " (auto)",
  continueAd: "Weiter (Werbung)",
  continueFree: "Weiter (gratis)",
  continueRetry: "Erneut versuchen",
  loadingAd: "Werbung lädt…",
  firstContinue: "Der erste Continue ist gratis.",
  adsRemovedContinue: "Werbung aus — Continue gratis.",
  watchAd: "Schau eine Werbung für eine Extra-Chance.",
  leftCount: "({n} übrig)",
  outOfContinues: "Keine Continues mehr.",
  duelCrash: "Der erste Crash beendet das Duell.",
  adUnavailable: "Werbung nicht verfügbar — nochmal versuchen oder Run beenden.",
  adsBlocked:
    "Werbung blockiert — erlaube sie unter Einstellungen → Werbe-Optionen, dann erneut versuchen.",
  watchWholeAd: "Schau die ganze Werbung, um weiterzumachen.",
  crash: "Crash!",
  newBest: "Neue Bestzeit!",
  runOver: "Run vorbei",
  theyCrashed: "Sie sind zuerst gecrasht",
  youCrashed: "Du bist zuerst gecrasht",
  deadHeat: "Unentschieden",
  duelOver: "Duell vorbei",
  vsLasted: " — du hast länger gehalten.",
  vsHeld: " — sie sind weiter gekommen.",
  vsSame: " — gleiche Distanz.",
  vsLine: "vs {name} {m} m",
  resultCoins: "+{coins} Coins · Best {best} m · {diff}",
  submitting: "Wird gesendet…",
  pickPseudo: "Wähl ein Pseudo für die Rangliste",
  offlineScore: "Offline — Score lokal gespeichert",
  rankImproved: "Global #{rank} · {total} Spieler",
  rankBestStill: "Best immer noch {best} m · #{rank}",
  choosePseudo: "Wähl dein Pseudo",
  savePseudo: "Pseudo speichern",
  asPlayer: "als {name}",
  editSettings: " · in den Einstellungen ändern",
  rematch: "Revanche",
  playAgain: "Nochmal",
  passPhone: "Handy weitergeben",
  shareInvite: "Teilen / Einladen",
  coinsPlus: "+{n} Coins",
  menu: "Menü",
  launchBonus: "Launch-Bonus",
  welcomeTitle: "✦{n} für dich",
  welcomeBody:
    "Erstes Öffnen dieser Version — etwas Fuel für die Garage. Nur einmal.",
  claimCoins: "✦{n} abholen",
  infoLead: "Neon-Kurier auf drei Spuren. So weit wie möglich — nicht crashen.",
  controls: "Steuerung",
  swipeLR: "Swipe L / R",
  swipeLRDesc: " — Spur wechseln",
  swipeUp: "Swipe hoch",
  swipeUpDesc: " — springen (braucht ein Token)",
  continueInfo: "Continue",
  continueInfoDesc: " — erster gratis, zweiter per optionaler Werbung (im Duell aus)",
  tapPower: "Tipp ⚡",
  tapPowerDesc: " — Fahrzeug-Power (oder Taste E)",
  twoPlayers: "2 Spieler",
  hotseatInfo: "Handy weitergeben",
  hotseatInfoDesc:
    " — nach einem Run auf {pass} tippen. Gleiche Strecke, dein Freund ist dran.",
  ranksDuelInfo: "Rangliste-Duell",
  ranksDuelInfoDesc:
    " — {ranks} → {duel} an einem Score. Du fährst genau diese Strecke.",
  shareInfo: "Link teilen",
  shareInfoDesc:
    " — nach einem Run {share}. Freund öffnet den Link und fährt deine Strecke.",
  twoPlayersRule:
    "Gleiche Hindernisse, gleicher Seed. Erster Crash verliert — keine Continues im Duell.",
  boardHint:
    "Tipp {duel} an einem Score, um dieselbe Strecke zu fahren — erster Crash verliert.",
  resultTwoP: "Mit einem Freund spielen",
  obstacles: "Hindernisse",
  rivalBikes: "Rivalen-Bikes",
  rivalDesc: "Spring drüber — sie bremsen hinter Kisten & Barriers.",
  trucks: "Trucks",
  truckDesc: "Zu hoch zum Springen. Spur wechseln.",
  barriers: "Barriers",
  barrierDesc: "Spring drüber, wenn du ein Token hast.",
  crates: "Kisten",
  crateDesc: "Sprung bringt dich drüber (manche Rides zerdeppern sie).",
  collectibles: "Collectibles",
  coinsTitle: "Coins (✦)",
  coinsDesc: "In der Garage ausgeben, um Rides freizuschalten.",
  jumpTokens: "Sprung-Tokens",
  jumpDesc: "Bis zu {n} sammeln — swipe hoch zum Nutzen.",
  infoFoot:
    "Das Tempo steigt im Run. Schwierigkeit vor dem Dash wählen. {garage} = Rides & Welten. {ranks} = Scores & Duelle. Tagesmissionen zahlen ✦.",
  missions: "Missionen {done}/{total}",
  missionsReady: " · abholen",
  claimed: "Abgeholt",
  playToStreak: "Spiel für den Streak",
  dayN: "Tag {n}",
  streakClaim: "✦{n} abholen",
  streakToast: "Streak +✦{n}",
  missionToast: "Mission +✦{n}",
  missionClaim: "✦{n} abholen",
  missionDone: "Fertig",
  shopTitle: "Shop",
  noAds: "Keine Werbung",
  noAdsBlurb: "Banner und Interstitials aus. Wiederherstellen geht weiter.",
  phantomPack: "Phantom-GT-Pack",
  phantomPackBlurb: "Phantom GT · ✦{n} · Keine Werbung",
  phantomPackGranted: " — bereits vergeben.",
  phantomPackShort: "Phantom-GT-Pack · {price}",
  coinPouch: "Coin-Beutel",
  coinChest: "Coin-Truhe",
  coinPackBlurb: "✦{n} für Autos & Welten.",
  owned: "Besitzt",
  adsRemoved: "Werbung entfernt.",
  adsRemovedWeb: "Werbung entfernt (Web-Test).",
  starterUnlocked: "Starter Pack freigeschaltet.",
  starterUnlockedWeb: "Starter freigeschaltet (Web-Test).",
  coinsGranted: "+✦{n} · Stand ✦{balance}",
  rides: "Rides",
  worlds: "Welten",
  statSpeed: "Tempo",
  statJump: "Sprung",
  statCoins: "Coins",
  noSpecialPower: "Keine Spezial-Power",
  passive: "Passiv",
  active: "Aktiv",
  equip: "Ausrüsten",
  equipped: "Ausgerüstet",
  tryRide: "Testen",
  tryRideHint: "Keine Coins, keine Ränge — nur eine Probefahrt.",
  practiceHud: "TEST",
  practiceOver: "Probefahrt",
  practiceNote: "Zählt nicht — keine Coins, keine Ränge.",
  practiceCrash: "Test vorbei — keine Coins, keine Ränge.",
  tryAgain: "Nochmal testen",
  backGarage: "Garage",
  getInShop: "Im Shop holen",
  needMore: "Noch ✦{n} nötig",
  buyPrice: "Kaufen · ✦ {n}",
  haveCoins: "✦ {price} · Du hast {have}",
  buyCoinsShop: "Coins im Shop kaufen",
  baseCoins: "Basis-Coins",
  extraCoins: "+{pct}% Coins",
  higherJump: " · höherer Sprung",
  jumpHoles: " · spring die Löcher",
  prevVehicle: "Vorheriges Fahrzeug",
  nextVehicle: "Nächstes Fahrzeug",
  prevWorld: "Vorherige Welt",
  nextWorld: "Nächste Welt",
  duelBanner:
    "Duell vs {name} · {m} m · {diff} · {stage} — dieselbe Strecke, erster Crash verliert.",
  cancel: "Abbrechen",
  vsHud: "vs {name} {m}m",
  iapProductUnavailable:
    "Produkt nicht verfügbar: Apple hat das IAP noch nicht freigegeben (Ready to Submit). Die Produkte existieren schon — nicht neu anlegen. Verkauf nach App Review.",
  iapStoreUnavailable:
    "Store nicht verfügbar — auf einem echten Gerät mit Sandbox-Apple-ID erneut versuchen.",
  iapFailed: "Kauf fehlgeschlagen: {reason}",
  shareDialog: "Teilen & Freunde einladen",
  shareCopied: "Score + Invite-Link kopiert!",
  shareNamed:
    "{who} hat {meters}m{diff} in 3Dash gedasht — erster Crash verliert.{challenge}",
  shareAnon:
    "Ich habe {meters}m gedasht und {coins} Coins in 3Dash{diff} geholt. Schlag meinen Run!{challenge}",
  shareChallenge: " Dieselbe Strecke: {url}",
  mission_play3: "Beende 3 Runs",
  mission_reach400: "Erreiche 400 m in einem Run",
  mission_coins20: "Sammle heute 20 Coins",
  mission_jumps8: "Spring heute 8 Mal",
  mission_beatBest: "Schlag deine Bestleistung",
  veh_dash_blurb: "Serien-Hoverbike. Ausgewogen und gratis.",
  veh_bulldog_blurb: "Schweres Chassis. Langsam, aber Kisten haben keine Chance.",
  veh_falcon_blurb: "Leichter Rahmen, gebaut für Airtime.",
  veh_magneto_blurb: "Coin-Staubsauger für lange Farm-Runs.",
  veh_wasp_blurb: "Stachel-Rahmen. Schneller, knackiger, keine Tricks.",
  veh_phantom_blurb: "Top-Speed. Ghost durch alles — kurz.",
  pow_none: "Keine Spezial-Power.",
  pow_none_wasp: "Keine Power — nur Pace.",
  pow_crush: "Kisten beim Impact zerdeppern. Barriers & Rivalen tun weiter weh.",
  pow_glider: "Gleiter — Sprung +60% länger und höher.",
  pow_magnet: "Coin-Magnet 6s. Cooldown 20s.",
  pow_phase: "Phase 3s — durch alle Hindernisse. Cooldown 30s.",
  stage_neon: "Neon City",
  stage_lunar: "Lunar Dust",
  stage_volcano: "Magma Run",
  stage_ice: "Ice Flats",
  stage_neon_blurb: "Nasse Spuren. Der klassische 3Dash-Run.",
  stage_lunar_blurb: "Niedrige Schwerkraft — Sprünge schweben. +25% Coins.",
  stage_volcano_blurb: "Lava-Risse — spring die Löcher. +50% Coins.",
  stage_ice_blurb: "Whiteout-Tempo. Lange Sprünge, dünne Eislöcher. +20% Coins.",
};
